import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Ruler from "../../Components/Ruler/Ruler";

export default function Weight() {
  const navigate = useNavigate();
  const location = useLocation();
  const [weightFromChild, setWeightFromChild] = useState(15);
  const { goal, activity, age, height } = location.state || {};

  const handleWeightChange = (newWeight) => {
    setWeightFromChild(newWeight);
  };

  const nextBtnHandler = () => {
    navigate("/start", {
      state: { goal, activity, age, height, weight: weightFromChild },
    });
    localStorage.setItem("weight", JSON.stringify(weightFromChild));
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="heightWeight centeredFlex">
            <h3 className="heightWeightHeading">وزن شما ؟</h3>
            <div className="heightWeightSelectorWrapper centeredFlex">
              <Ruler from="weight" onWeightChange={handleWeightChange} />
              <img
                className="bodyVector"
                src="/images/body.svg"
                alt="body vector"
              />
            </div>
            <div className="heightWeightBtn">
              <button className="nextQuestion" onClick={nextBtnHandler}>
                بعدی
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
